// extracted by mini-css-extract-plugin
export var callCard = "_nw-0";
export var callMessageButton = "_nw-1";
export var helpIcon = "_nw-3";
export var helpIconContainer = "_nw-4";
export var verticalDivider = "_nw-2";